import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { EventBaseCard } from '@/shared/ui/cards'
import { IEventPreview } from '@/enitites/event/model/types'
import { getDateFormatted } from '@/services/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPreviewBaseCardMobile',
  props: {
    previewEvent: null
  },
  setup(__props: any) {

const { getImageById } = useImage()


return { __sfc: true,getImageById, EventBaseCard, getDateFormatted }
}

})